import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';

/**
 * Material-first top bar wrapper.
 *
 * Slots:
 *  - [left]   : left side content (menu/home)
 *  - default  : center content (title)
 *  - [right]  : right side actions
 */
@Component({
    standalone: true,
    selector: 'app-topbar',
    imports: [CommonModule, MatToolbarModule],
    templateUrl: './app-topbar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTopbarComponent {
    /** Set to true to make the bar stick to the top. */
    @Input() sticky: boolean = true;
}
